//@ts-check

/**
 * @param {import('./types').ExportFileFormat} format
 */
var getMimeType = function getMimeType(format) {
  if (!format) throw new Error(format + ' is required');
  if (format === 'CSV') return 'data:text/csv;charset=utf-8';
  throw new Error(format + ' not supported');
};
/**
 * @param {import('./types').ExportFileFormat} format
 */


var getExtension = function getExtension(format) {
  if (format === 'CSV') return 'csv';
};
/**
 * Download a file based on data
 * @param {string} data
 * @param {import('./types').ExportFileFormat} format
 * @param {string} filename
 */


var saveFile = function saveFile(data, format) {
  var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Download';
  var extension = getExtension(format);
  var name = filename.endsWith('.' + extension) ? filename : filename + '.' + extension;
  var fileContent = getMimeType(format) + ',' + data;
  var encodedUri = encodeURI(fileContent);
  var link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
};

export default saveFile;